/*eslint-disable*/
import Flickity from 'flickity'

export default slider => {
  let $slider = $(slider)
  let isFlickity = false;
  let article_flkty;
  const setFlickity = slider => {
    isFlickity && $(slider).on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    isFlickity && $(slider).on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
    article_flkty = new Flickity(slider, {...params})
    isFlickity = !isFlickity; 
  }

  let params = {
    wrapAround: true,
    draggable: true,
    cellAlign: 'center',
    adaptiveHeight: true,
    prevNextButtons: true,
    imagesLoaded: true
  }

  $(window).on('load resize', ()=>{   
      setFlickity(slider)
      article_flkty && article_flkty.resize()
  })
}


// WEBPACK FOOTER //
// ./src/scripts/components/the-every-edit-quiz.js